<div
  data-testid="tool-line"
  class="flex flex-col gap-0.5 text-xs"
  [class]="tool().access === 'read' ? 'text-text-secondary' : 'text-text-primary'">
  <div class="flex min-w-0 items-center gap-1.5">
    <i class="shrink-0" [class]="icon()"></i>
    <span class="truncate font-mono">{{ label() }}</span>
    @if (tag(); as tag) {
      <span
        class="border-default text-text-tertiary text-2xs shrink-0 rounded-full border px-1.5 font-medium">
        {{ tag | translate }}
      </span>
    }
    @if (detail() && duration(); as duration) {
      <span class="text-text-tertiary text-2xs ml-auto shrink-0 font-mono tabular-nums">
        {{ duration }}
      </span>
    }
  </div>
  @if (detail()) {
    <div class="flex min-w-0 items-start gap-1.5 pl-5">
      <code
        class="text-text-tertiary text-2xs min-w-0 flex-1 font-mono"
        [class]="showAll() ? 'break-all whitespace-pre-wrap' : 'truncate'"
        >{{ args() }}</code
      >
      @if (long()) {
        <button
          type="button"
          class="text-text-tertiary hover:text-text-primary text-2xs shrink-0 rounded-sm transition-colors"
          [attr.aria-expanded]="showAll()"
          (click)="showAll.set(!showAll())">
          {{
            (showAll() ? 'assistant.chrome.show_less' : 'assistant.chrome.show_more')
              | translate
          }}
        </button>
      }
    </div>
  }
</div>
